import styles from "./BuserBottomBar.module.scss";
import clsx from 'clsx';
import nextStepArrow from "@/assets/icons/next_step_arrow.png";
import { useEffect, useMemo, useState } from "react";
import DownArrowIcon from "../../assets/icons/arrow_down_black.svg";
import UpArrowIcon from "../../assets/icons/arrow_up.svg";
import threePointIcon from "../../assets/icons/three_point.png";
import buyIcon from '../../assets/icons/buy.png';
import storeIcon from '../../assets/icons/store.png';
import { hide_guide_step_gio, show_guide_step_gio } from "@/utils/gioUtils";

interface IProps {
  nextSteptext: string;
  nowProgess?: number;
  extraText?: string;
  expandExtraText?: string;
  extraPng?: string;
  nextStepBtnText?: string;
  nextStepFn?: ((isShowAll?: boolean) => void) | null;
  extraFunc?: (() => void) | null;
  showAll?: boolean;
  showBar?: boolean;
  nowPage?: string;
  modify?: number; // PAX-6922：因为abtest，一开始需要弹窗隐藏，再点下一步，不论阴部隐藏，都要隐藏
}

export interface IPageTypeParams {
  pageType_var: string;
  pageName_var: string;
}

function BuserBottomBar(props: IProps) {
  const isOnline2offline = sessionStorage.getItem('abtestPaxOnline2offline') === 'SHOW'
  const { nowProgess = 0, nowPage, nextSteptext, extraText, expandExtraText,
    extraPng, nextStepBtnText, showAll, showBar, nextStepFn, extraFunc, modify } = props; 
  const [isShowAll, setIsShowAll] = useState(showAll ? showAll : false);
  const [isShowBar, setIsShowBar] = useState(showBar ? showBar : false);
  
  const handleClick = () => {
    if (nextStepFn) {
        nextStepFn(isShowAll);
    }
  }

  const handleExtraClick = () => {
    if (extraFunc) {
        extraFunc();
    }
    setIsShowAll(false);
  }

  const nowPageParams = useMemo(() => {
    const params = {pageType_var: '-', pageName_var: '-'} as IPageTypeParams;
    if (nowPage === 'BasicInfo') {
      params.pageType_var = 'pax_requirement';
      params.pageName_var = '1/3衣柜基础信息';
    }
    if (nowPage === 'InteriorFilter') {
      params.pageType_var = 'pax_requirement';
      params.pageName_var = '2/3选择内配方案';
    }
    if (nowPage === 'Overview') {
      params.pageType_var = 'pax_template_overview';
      params.pageName_var = '2/3选择内配方案';
    }
    if (nowPage === 'SelectExteriorStyle') {
      params.pageType_var = 'pax_adjustment';
      params.pageName_var = '3/3衣柜外观样式';
    }
    if (nowPage === 'InteriorEditor') {
      params.pageType_var = 'pax_editor';
      params.pageName_var = '2/3替换内配布局';
    }
    return params;
  }, [nowPage]);

  useEffect(() => {
    setIsShowAll(!!showAll);
  }, [showAll, modify]);

  return (
    <div className={styles.wrap}>
      {isShowBar && (
      <div className={clsx(styles.paxProgress, { [styles.paxProgress_show]: isShowAll, [styles.paxProgress_hide]: !isShowAll })}>
        <div className={styles.paxProgressTitle} onClick={() => { setIsShowAll(false); show_guide_step_gio(nowPageParams) }}>
            <span>PAX衣柜自主设计工具流程</span>
            <img src={DownArrowIcon} alt=""/>
        </div>
        <div className={styles.step}>
          <span className={styles.numBlue}>1</span>
          <span className={styles.numTextBlue}>尺寸柜型</span>
          <img className={styles.stepByStep} src={threePointIcon} alt="" />
          <span className={clsx({ [styles.numBlue]: nowProgess >= 2, [styles.num]: nowProgess < 2 })}>2</span>
          <span className={clsx({ [styles.numTextBlue]: nowProgess >= 2, [styles.numText]: nowProgess < 2 })}>内配布局</span>
          <img className={styles.stepByStep} src={threePointIcon} alt="" />
          <span className={clsx({ [styles.numBlue]: nowProgess >= 4, [styles.num]: nowProgess < 4 })}>3</span>
          <span className={clsx({ [styles.numTextBlue]: nowProgess >= 4, [styles.numText]: nowProgess < 4 })}>外观选择</span>
          <img className={styles.stepByStep} src={threePointIcon} alt="" />
          <span className={styles.num}>4</span>
          <span className={styles.numText}>设计完成下单</span>
        </div>
        <div className={styles.online2offline} style={{ display: isOnline2offline ? 'block' : 'none'}}>
          <div className={styles.rowBox}>
            <div className={styles.content}>可直接线上下单购买，高效快速</div>
            <img src={buyIcon} width={42} height={48} alt="buy" style={{ position: 'absolute', bottom: '0', right: '22px' }} />
          </div>
          <div className={styles.rowBox}>
            <div className={styles.content}>你也可前往门店查看实物或找员工购买</div>
            <img src={storeIcon} width={54} height={33.5} alt="store" style={{ position: 'absolute', bottom: '0', right: '16.5px' }} />
          </div>
        </div>
      </div>
      )}
      <div className={styles.nextStepBtn}>
        <div className={styles.buserBottomBarWrap}>
          <div className={clsx(styles.progressBar, { [styles.hasProgressBar]: !isShowAll, [styles.noProgressBar]: isShowAll })} onClick={() => {setIsShowBar(true); setIsShowAll(true); hide_guide_step_gio(nowPageParams)}}>
            <div className={styles.text}>
              <span>{nextSteptext}</span>
              <img src={UpArrowIcon} alt="" />
            </div>
            <div className={styles.totalStep}>
              <div className={styles[`nextStep-${nowProgess}`]}></div>
            </div>
          </div>
          {!!extraText ? (
            <div className={clsx(styles.extra, { [styles.extraFunctionWrap]: !isShowAll, [styles.extraBtn]: isShowAll })} onClick={handleExtraClick}>
              <img className={styles.OptIcon} src={extraPng} alt='' />
              {isShowAll ? (
                <span>{expandExtraText}</span>
              ) : (
                <span>{extraText}</span>
              )}
            </div>
          ) : null}
          <div className={clsx(styles.main, { [styles.arrowWrap]: !isShowAll, [styles.singleBtn]: isShowAll && !!extraText, [styles.doubleBtn]: isShowAll && !extraText })} onClick={handleClick}>
            {!isShowAll ? (<img src={nextStepArrow} alt="" />) : (<span className={styles.nextStep}>{nextStepBtnText}</span>)}
          </div>
        </div>
      </div>
      {/* {!isShowAll ? (
        <div className={styles.nextStepBtn}>
        <div className={styles.buserBottomBarWrap}>
          <div className={styles.progressBar} onClick={() => {setIsShowBar(true); setIsShowAll(true)}}>
            <div className={styles.text}>
              <span>{nextSteptext}</span>
              <img src={UpArrowIcon} alt="" />
            </div>
            <div className={styles.totalStep}>
              <div className={styles[`nextStep-${nowProgess}`]}></div>
            </div>
          </div>
          {!!extraText ? (
            <div className={styles.extraFunctionWrap} onClick={handleExtraClick}>
              <img className={styles.OptIcon} src={extraPng} alt='' />
              <span>{extraText}</span>
            </div>
          ) : null}
          <div className={styles.arrowWrap} onClick={handleClick}>
            <img src={nextStepArrow} alt="" />
          </div>
        </div>
        </div>
      ) : (
        <div className={styles.nextStepBtn}>
          {extraText && (
            <div className={styles.extraBtn}>
                <img className={styles.OptIcon} src={extraPng} alt='' />
              <span>{extraText}</span>
            </div>
          )}
          <div className={styles.Btn} onClick={handleClick}>{nextStepBtnText}</div>
        </div>
      )} */}
    </div>
  )
}

export default BuserBottomBar;

